/**
 * endorsementTypes — the four endorsements, and the one name that differs.
 *
 * Kept apart from `endorsementsApi` so the payload adapter and the API client
 * can both use it without importing each other.
 *
 * The list matches Symfony's `UpdateUserEndorsementRequestDto` one-for-one;
 * only the tailwheel key differs in case (`tailwheel` here, `tailWheel` on the
 * wire), which is what `apiKeyFor` exists for.
 */
export const ENDORSEMENT_TYPES = [
	{ key: 'complex', label: 'Complex' },
	{ key: 'performance', label: 'High Performance' },
	{ key: 'tailwheel', label: 'Tailwheel' },
	{ key: 'highAltitudeOperations', label: 'High Altitude Operations' }
];

const API_KEY = { tailwheel: 'tailWheel' };

/** Our key → the field name Symfony reads and writes. */
export const apiKeyFor = key => API_KEY[key] || key;
